const login = () => import("@/views/Login/Login.vue");
const dashboard = () => import("@/views/Dashboard/Dashboard.vue");
const usuarios = () => import("@/views/Usuarios/Usuarios.vue");
const grupos = () => import("@/views/Grupos/Grupos.vue");

const routes = [
  {
    path: "/login",
    name: "Login",
    slug: 'login',
    component: login,
    title: "Login",
    icon: "",
    menu: false,
    meta: {
      requireAuth: false,
      isAdmin: false,
      isNotAnalista: false,
    },
  },
  {
    path: "/",
    name: "Dashboard",
    component: dashboard,
    title: "Dashboard",
    icon: "mdi-view-dashboard",
    menu: true,
    meta: {
      requireAuth: true,
      isNotAnalista: false,
      isAdmin: false,
    },
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: usuarios,
    title: "Usuarios",
    icon: "mdi-account",
    menu: true,
    meta: {
      requireAuth: true,
      isNotAnalista: false,
      isAdmin: true,
    },
  },
  {
    path: "/grupos",
    name: "Grupos",
    component: grupos,
    title: "Grupos",
    icon: "mdi-account-group",
    menu: true,
    meta: {
      requireAuth: true,
      isNotAnalista: true,
      isAdmin: false,
    },
  },
];

export default routes;